import { createNewInterview, createWorker, editWorker, getWorkers, getWorkerJobs, getWorkerJobsCompleted } from '../api';
import { dispatchErrorAction } from './index';
import { CLEAR_WORKER_DETAILS, GET_ALL_WORKERS_SUCCESS, GET_WORKER_JOBS_SUCCESS, GET_WORKER_JOBS_COMPLETED_SUCCESS } from './actionTypes';
import { formatJobsList } from '../helpers/fromServer';
import { JOBS_LIST_PAGE_SIZE, USERS_LIST_PAGE_SIZE } from '../constants/general';
import { getPagesCount } from '../helpers/general';

export function getAllWorkers (skip = 0, filterData) {
  return dispatch => getWorkers(skip, filterData)
    .then(({ data }) => {
      const pagesQuantity = getPagesCount(data.count, USERS_LIST_PAGE_SIZE);
      dispatch({ type: GET_ALL_WORKERS_SUCCESS, workersList: data.data, pagesQuantity });
      return { data: data.data, pagesQuantity };
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function clearWorkerDetails () {
  return dispatch => dispatch({ type: CLEAR_WORKER_DETAILS });
}

export function createNewWorker (payload) {
  return dispatch => createWorker(payload)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function editWorkerUser (id, payload) {
  return dispatch => editWorker(id, payload)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function createNewInterviewAction (interviewData) {
  return dispatch => createNewInterview(interviewData)
    .then(({ data }) => data)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function getAllWorkerJobs (skip = 0, data) {
  return dispatch => getWorkerJobs(skip, data)
    .then(({ data }) => {
      const pagesQuantity = getPagesCount(data.count, JOBS_LIST_PAGE_SIZE);
      dispatch({ type: GET_WORKER_JOBS_SUCCESS, jobsList: formatJobsList(data.data), pagesQuantity });
      return data.data;
    })
    .catch(error => {
      dispatchErrorAction(error, dispatch);
    });
}

export function getWorkerJobsCompletedAction (id) {
  return dispatch => getWorkerJobsCompleted(id)
    .then(({ data }) => dispatch({ type: GET_WORKER_JOBS_COMPLETED_SUCCESS, jobs: data.jobs  }))
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/workers.js